// extracted by mini-css-extract-plugin
module.exports = {"imageSlider":"CaseStudySlider-module--imageSlider--lPx5k"};